import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEars = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 80,
	height: 32,
	viewBox: "0 0 70.0059 28.2265",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 19",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Ellipse 19",
			d: "M19.0463 15.4276C19.5279 22.6896 19.9997 26.3233 14.4508 26.6913C8.90193 27.0593 1.94744 30.5996 1.46581 23.3375C0.984175 16.0754 10.6382 0.530127 15.0707 0.236153C20.6196 -0.131856 18.5646 8.16547 19.0463 15.4276Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Ellipse 20",
			d: "M52.0462 15.466C51.5243 22.7253 51.0473 26.3574 56.2354 26.7303C61.4236 27.1033 67.8957 30.6487 68.4176 23.3894C68.9394 16.1301 60.0592 0.581006 55.9148 0.283089C50.7266 -0.089856 52.568 8.20667 52.0462 15.466Z",
			fill: "white"
		})]
	})
});
export default SvgEars;
